export default __webpack_public_path__ + "static/media/ancho_compra_producto.632721bb.svg";